import { render, staticRenderFns } from "./FacebookDialog.vue?vue&type=template&id=0c0244b0&scoped=true&"
import script from "./FacebookDialog.vue?vue&type=script&lang=js&"
export * from "./FacebookDialog.vue?vue&type=script&lang=js&"
import style0 from "./FacebookDialog.vue?vue&type=style&index=0&id=0c0244b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0244b0",
  null
  
)

export default component.exports